export default {
    created(){
        window.addEventListener("resize", this.resizeEventHandler);
    },  
    destroyed() {
        window.removeEventListener("resize", this.resizeEventHandler);
    },          
    data() {
        return {   
            wInnerHeight: window.innerHeight, // you need this for the height when creating fixed-height tables
        }   
    },
    computed:{
        current_size: function(){	
            return this.$vuetify.breakpoint.name;
        },
    }, 
    methods: {
        resizeEventHandler(){
            this.wInnerHeight = window.innerHeight;  
            console.log('screen-size', this.current_size, 'windows-height', this.wInnerHeight);
        },     
    }
}    